export default {
  'thanks23': {
    title: 'THANKS!イラスト　第23話分',
    image: '/assets/images/special-banner-thanks23.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks23.jpg">' +
      '  <figcaption>サブキャラクターデザイン・総作画監督：加藤寛崇</figcaption>' +
      '</figure>' +
      '<div class="level-center is-mobile">' +
      '<a href="/assets/images/special-thanks23.jpg" download="great-pretender.jpg">' +
      '  <button class="level-center is-mobile is-size-2 is-size-4-mobile"><span class="icon-download"></span>イラストをダウンロード</button>' +
      '</a>' +
      '</div>'
  },
  'thanks22': {
    title: 'THANKS!イラスト　第22話分',
    image: '/assets/images/special-banner-thanks22.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks22.jpg">' +
      '  <figcaption>コンセプトデザイン：丹地陽子</figcaption>' +
      '</figure>'
  },
  'thanks21': {
    title: 'THANKS!イラスト　第21話分',
    image: '/assets/images/special-banner-thanks21.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks21.jpg">' +
      '  <figcaption>作画監督：北山修一</figcaption>' +
      '</figure>'
  },
  'thanks20': {
    title: 'THANKS!イラスト　第20話分',
    image: '/assets/images/special-banner-thanks20.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks20.jpg">' +
      '  <figcaption>演出・作画監督：手島舞</figcaption>' +
      '</figure>'
  },
  'thanks19': {
    title: 'THANKS!イラスト　第19話分',
    image: '/assets/images/special-banner-thanks19.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks19.jpg">' +
      '  <figcaption>作画監督：河毛雅妃</figcaption>' +
      '</figure>'
  },
  'thanks18': {
    title: 'THANKS!イラスト　第18話分',
    image: '/assets/images/special-banner-thanks18.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks18.jpg">' +
      '  <figcaption>原画・作画監督補佐：万怡</figcaption>' +
      '</figure>'
  },
  'thanks17': {
    title: 'THANKS!イラスト　第17話分',
    image: '/assets/images/special-banner-thanks17.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks17.jpg">' +
      '  <figcaption>原画：上関彩花</figcaption>' +
      '</figure>'
  },
  'thanks16': {
    title: 'THANKS!イラスト　第16話分',
    image: '/assets/images/special-banner-thanks16.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks16.jpg">' +
      '  <figcaption>原画：簑輪愛子</figcaption>' +
      '</figure>'
  },
  'thanks15': {
    title: 'THANKS!イラスト　第15話分',
    image: '/assets/images/special-banner-thanks15.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks15.jpg">' +
      '  <figcaption>OPアニメーター：松本幸子</figcaption>' +
      '</figure>'
  },
  'interview01': {
    title: '古沢良太 オフィシャルインタビュー',
    image: '/assets/images/special-banner-interview01.jpg',
    indent: false,
    text:
      '<h1 class="title">いよいよ本日より最終章・CASE4放送スタート！<br>' +
      '壮大な物語の誕生秘話を語る！<br>' +
      '古沢良太（脚本・シリーズ構成）オフィシャルインタビュー公開</h1>' +
      '<time>2020.10.21</time>' +
      '<p>　</p>' +
      '<h2 class="is-yellow">【3つのCASEの誕生秘話】</h2>' +
      '<p><em>ー『GREAT PRETENDER』の脚本を執筆するにあたり、難しかったのはどんな点ですか。</em></p>' +
      '<p>古沢良太（以下、古沢）「コンゲームものの難しさは、主人公と悪役がなかなか正面切ってぶつかり合えないことです。「自分は味方です」って顔をして近づいていかなきゃいけない。そういう描写を積み上げていって、最後に「騙していた」と明かされることでカタルシスが生まれる。観客にそこまで我慢してもらわなければいけないので、積み上げていく過程をどう面白く見せるかが難しい。逆に言えば、そこを楽しんでもらえれば、僕としては嬉しいです。」</p>' +
      '<p>　</p>' +
      '<p><em>ー今作は全23話が4章に分かれ、それぞれにフィーチャーするキャラクターの過去のドラマが盛り込まれています。この構成を採用した意図は？</em></p>' +
      '<p>古沢「あくまでも主人公たちの物語にしたかったので。今言った「積み上げていく過程」の中で、主人公たちの人生、人間ドラマで見せていきたい。そういう意図でした。」</p>' +
      '<figure class="is-large">' +
      '  <img src="/assets/images/special-interview01-1.jpg" alt="CASE 1">' +
      '</figure>' +
      '<p><em>ーCASE1「ロサンゼルス・コネクション」はエダマメにスポットが当たり、舞台はハリウッド。ターゲットは映画プロデューサーでもあるハリウッドマフィアでした。</em></p>' +
      '<p>古沢「CASE1はとにかく広い世界にエダマメを引っ張り出して、今まで日本でやってきた姑息な詐欺とは違う、巨悪が絡むスケールの大きな詐欺に巻き込みたかった。そうなるとやはりアメリカ、ロサンゼルスとかいいんじゃないかなって。アメリカ西海岸のカラッと明るい雰囲気が、日本との対比になって絵的にもおもしろそうですし。そしてロサンゼルスと言えばハリウッドかなと。当時、ハリウッドの映画プロデューサーにまつわる事件も実際に起きていたので、それも参考にしたりしました。」</p>' +
      '<p>　</p>' +
      '<p><em>ーエダマメという人物を描くときに意識したことは？</em></p>' +
      '<p>古沢「エダマメは、大人になる前の男の子というイメージです。自分の生き方に迷っていて、すぐに気が変わったりもして、時には調子に乗って痛い目にも遭って。それでもめげずに、とにかくがむしゃらに七転八倒して生きている若者。そこに共感してもらいたいと思って書きました。」</p>' +
      '<p>　</p>' +
      '<p><em>ー英語が訛っている、という設定には何か理由が？</em></p>' +
      '<p>古沢「理由と言われると……何でかな？（笑）　どう思いついたかはもう覚えてないですが。アニメだと普通、言語の壁はないものとして進めますよね。でも、そこが何か詐欺のギミックとしても使えるんじゃないかとか、（言語の違いという）枷があるからこそおもしろくなる部分があるんじゃないかとか、そう思ってちょっとやってみたかったんです。書いているときは、「今は日本語をしゃべっている」「これは英語でしゃべっている」と考えながら書いていたけれど、途中からフランス語が出てきたり中国語が出てきたりして、「今、何語だ？」とわけがわからなくなって後悔したりもしました（笑）。でも結果的に、CASE4はそこがキーになるお話が書けたので、上手く生かすことができました。やってよかったです。」</p>' +
      '<figure class="is-large">' +
      '  <img src="/assets/images/special-interview01-2.jpg" alt="CASE 2">' +
      '</figure>' +
      '<p><em>ー続くCASE2「シンガポール・スカイ」はアビーが軸の物語でした。アビーはどのように描きたいと考えたのでしょう？</em></p>' +
      '<p>古沢「アビーはヒロイン的な立ち位置で、エダマメと恋愛関係になるような展開になりがちですが、個人的にはそこでドラマがベタつくのが嫌でした。だから、もっとドライな関係でいられるように、かわいげのない、野生の獣のようなキャラクターに（笑）。でも、それが逆に魅力的に見えるようになったらいいなとも思っていました。」</p>' +
      '<p>　</p>' +
      '<p><em>ーコンゲームの題材はエアレースでしたね。</em></p>' +
      '<p>古沢「スポーツやレースの詐欺は、昔からの定番です。最初は普通にＦ１のカーレースを考えていたけれど、せっかくアニメだし、飛行機にしようかなと（笑）。当時、ＴＶでエアレースの中継をよくやっていたし、シンガポールのクールな街並みを飛行機が飛び回ってレースをすれば、アニメらしい素敵な絵が観られそうですから。」</p>' +
      '<p>　</p>' +
      '<p><em>ー現実のエアレースって、あんなに街中を飛ぶものなのですか？</em></p>' +
      '<p>古沢「いや、飛ばないです（笑）。でも、あれくらいの荒唐無稽さもアニメなら許されるんじゃないかなって。実際、鏑木（ひろ）監督たちがエアレースを観に行ったり、シンガポールにロケハンに行って飛ぶコースを細かく考えてくれたりしたので、見応えのある映像になりましたよね。」</p>' +
      '<figure class="is-large">' +
      '  <img src="/assets/images/special-interview01-3.jpg" alt="CASE 3">' +
      '</figure>' +
      '<p><em>ーそしてCASE3「スノー・オブ・ロンドン」はアートビジネスが題材で、一転してしっとりしたフランス映画のようなドラマになっていました。</em></p>' +
      '<p>古沢「CASE2がかなり派手になりそうだったので、シンシアの話だし、ちょっと大人のドラマにしたいと思いました。だから美術品を題材にして。そして、恋の話ですね。」</p>' +
      '<p>　</p>' +
      '<p><em>ーCASE3でシンシアを描く時に考えたことは？</em></p>' +
      '<p>古沢「メインキャラの中では唯一の大人の女性なので、大人の余裕と色気と……でも、お母さん的な存在に完全になってしまうのも嫌で。大人の女性も少女だった時代があるし、今でも少女の部分は持っているはず。CASE3は、それが感じられるようなエピソードにしたいと思いました。それとシンシアは、キャラクターデザインの貞本（義行）さんにビジュアルイメージを聞かれたとき、メリル・ストリープの名前をあげたんです。そこからの発想で、詐欺師で演技が上手いというのもあるし、若い頃に演劇をやっていたんじゃないかな、と。そして、『フェーム』とか『フラッシュ・ダンス』とか、そういう青春映画のような雰囲気のエピソードにしたいと思いました。」</p>' +
      '<p>　</p>' +
      '<h2 class="is-yellow">【謎めいた男の過去が……】</h2>' +
      '<p><em>ー各エピソードのコンゲームの仕掛けは、どのように組み立てていったのでしょうか。</em></p>' +
      '<p>古沢「うーん……無理矢理ひねり出しています（笑）。たくさん考えて、書いて、そして監督たちに読んでもらって、意見をもらって書き直して……と繰り返し。とにかく一生懸命に書いたという感じです。あとは（詐欺の）ターゲットが何を求めているか、なにをほしがっているか、ですね。人は何を目の前にぶら下げられると食いついてしまうのか。それをドラマの軸にすることは、ずっと考えていたと思います。」</p>' +
      '<p>　</p>' +
      '<p><em>ー騙される側の欲望ですね。</em></p>' +
      '<p>古沢「そうですね。ただ、欲望のない人間はいないし、必ずしもそれは悪いものでもない。むしろ、自分の欲望に純粋に生きている人や、それを隠さずに表現して生きている人は素敵だなと思うようになりました。欲望に従順な人たちが世界を前に進めてきた。そんな気もします。」</p>' +
      '<p>　</p>' +
      '<p><em>ー一方、騙す側の主人公たちを魅力的に描く上でのポイントは？</em></p>' +
      '<p>古沢「まあ、詐欺師であるとかないとかとは関係なく、人間としてキュートで、どこか孤独を抱えている人たち、ということでしょうか。そして、詐欺にしろ何にしろ命がけで何かをする姿――そんな彼らのあいだの不思議な人間関係が、魅力的に見えたらいいなと思って書いていたと思います。」</p>' +
      '<figure class="is-large">' +
      '  <img src="/assets/images/special-interview01-4.jpg" alt="CASE 4">' +
      '</figure>' +
      '<p><em>ーそして、いよいよCASE4「ウィザード・オブ・ファー・イースト」がスタートします。ここではやはりローランの過去が描かれるのでしょうか？</em></p>' +
      '<p>古沢「そうなります。ローランはセクシーで頭が切れて、そして、とにかく謎に包まれた得体が知れない男として、ここまで描いてきました。どこまで考えているのか、考えていないのかもわからない。完璧主義なのかマヌケなのかもわからない（笑）。そんな謎に包まれた男のままにしておくのもいいかなと思いつつ、まあでも、せっかくCASE3までひとりひとりのドラマを掘り下げてきたので、CASE4はしっかりとローランの物語を描きたいと思いました。そこで、ドロシーというカギを握る新キャラクターが登場します。」</p>' +
      '<p>　</p>' +
      '<p><em>ーCASE3のラストで、ローランがペンダントに「なぁ、ドロシー」と話しかけていました。そのドロシーですね。</em></p>' +
      '<p>古沢「ドロシーという女性はとても重要な、いわば“最後のヒロイン”ともいえるキャラクター。僕自身も楽しんで書きました。CASE4ではローランの過去が解き明かされます。ローランとドロシーとの物語がすべてのはじまりであるということ、そして、そこに運命に導かれるようにエダマメも関係していくこと……すべてがわかると思います。コンゲームのターゲットは東京と上海の犯罪組織です。エダマメやローランはヤクザ同士の抗争という危険な世界に潜り込んでいくことになります。クライマックスに相応しい手に汗握る展開と、濃密な人間ドラマを楽しんでいただきたいです。きっと満足していただけるCASE4になっていると思います。」</p>'
  },
  'thanks14': {
    title: 'THANKS!イラスト　第14話分',
    image: '/assets/images/special-banner-thanks14.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks14.jpg">' +
      '  <figcaption>原画：立石睦実</figcaption>' +
      '</figure>'
  },
  'thanks13': {
    title: 'THANKS!イラスト　第13話分',
    image: '/assets/images/special-banner-thanks13.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks13.jpg">' +
      '  <figcaption>作画監督：荒尾英幸</figcaption>' +
      '</figure>'
  },
  'thanks12': {
    title: 'THANKS!イラスト　第12話分',
    image: '/assets/images/special-banner-thanks12.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks12.jpg">' +
      '  <figcaption>美術設定：藤井 一志</figcaption>' +
      '</figure>'
  },
  'thanks11': {
    title: 'THANKS!イラスト　第11話分',
    image: '/assets/images/special-banner-thanks11.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks11.jpg">' +
      '  <figcaption>イメージデザイン：syo5</figcaption>' +
      '</figure>'
  },
  'thanks10': {
    title: 'THANKS!イラスト　第10話分',
    image: '/assets/images/special-banner-thanks10.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks10.jpg">' +
      '  <figcaption>原画・作画監督補佐：西島央桐</figcaption>' +
      '</figure>'
  },
  'thanks09': {
    title: 'THANKS!イラスト　第9話分',
    image: '/assets/images/special-banner-thanks09.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks09.jpg">' +
      '  <figcaption>原画・作画監督補佐：島袋奈津希</figcaption>' +
      '</figure>'
  },
  'thanks08': {
    title: 'THANKS!イラスト　第8話分',
    image: '/assets/images/special-banner-thanks08.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks08.jpg">' +
      '  <figcaption>原画：中田久美子</figcaption>' +
      '</figure>'
  },
  'thanks07': {
    title: 'THANKS!イラスト　第7話分',
    image: '/assets/images/special-banner-thanks07.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks07.jpg">' +
      '  <figcaption>作画監督：阿部愛由美</figcaption>' +
      '</figure>'
  },
  'thanks06': {
    title: 'THANKS!イラスト　第6話分',
    image: '/assets/images/special-banner-thanks06.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks06.jpg">' +
      '  <figcaption>総作画監督：浅野恭司</figcaption>' +
      '</figure>'
  },
  'fake03': {
    title: '特集記事「日本発！サクラマジックとは」',
    image: '/assets/images/special-banner-fake03.jpg',
    button: 'コメントを書く',
    shareUrl: '/special/fake03',
    twitter: '#今週もプリテンドされました #サクラマジック #ハイなクオリティ #凄腕女性捜査官投入  #博士の異常な飴玉 #グレプリ',
    text:
      '<h1 class="title">日本発!　これぞ最先端!<br>『サクラマジック』がL.A.で大流行!?</h1>' +
      '<time>2020.08.07</time>' +
      '<figure class="is-large">' +
      '  <img src="/assets/images/special-fake03.jpg">' +
      '</figure>' +
      '<h2>ー メイドインジャパンはハリウッドにも？セレブ御用達のハイ（！）クォリティ！</h2>' +
      '<p>最近、ロサンゼルスではメイドインジャパンのおクスリが流行の兆しだ。といっても、風邪薬やアレルギーの薬ではなく、手が後ろに回る違法な代物である。</p>' +
      '<p>モノ作りで一世を風靡した時代は今や昔、メイドインジャパンで誇れる物はいくつ残っているだろう？車？アニメ？温水洗浄便座？そんな数少ない日本製の薬を、ハリウッドセレブ達が注目してるらしいのだ。</p>' +
      '<p>これは先日の調査から判明したものだが、カッサーノ邸に訪れていた日本人はE博士。日本のとある化学薬品研究所に在籍していたようだ。彼が開発した新薬は効き目の強さにより開発が一旦凍結、またその才能に嫉妬した同業者らにより研究所を追い出されてしまったようである。</p>' +
      '<p>そんなE博士が生み出したのが新型合成麻薬『サクラマジック』なのだ。</p><br>' +
      '<p>ロス市警の調べでは、気軽に持ち運べるキャンディ状に加工されており、舐めて服用出来るらしい。しかも無味無臭で尿にも出ない。効き目も抜群のようで、サクラマジックを服用した新人女優は跳ね回って悦んでいたとのこと。</p>' +
      '<p>日本では不遇なE博士が、ロスに呼ばれて栄光を掴む…これぞメイドインジャパンによるアメリカンドリームの体現と言えよう。</p>' +
      '<p>我々はカッサーノ氏と並行してE博士も調査対象とすべく、A警部と共に足取りを追うことにした。</p>' +
      '<p>聞くところによれば、調査難航中のA警部の元に強力な助っ人が投入されたらしい。素性は明らかでないが、凄腕の女性捜査官だとか…。近々この人物にも接触を試みるつもりだ、期待していて欲しい。</p>'
  },
  'thanks05': {
    title: 'THANKS!イラスト　第5話分',
    image: '/assets/images/special-banner-thanks05.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks05.jpg">' +
      '  <figcaption>作画監督：清水裕輔</figcaption>' +
      '</figure>'
  },
  'fake02': {
    title: '映画レビュー「灼熱の要塞」',
    image: '/assets/images/special-banner-fake02.jpg',
    button: 'ユーザーレビューを書く',
    shareUrl: '/special/fake02',
    twitter: '#今週もプリテンドされました #灼熱の要塞レビュー #割り箸アクション #もっとライスを食べたほうがいい #人として大切なもの #グレプリ',
    text:
      '<h1 class="title">映画レビュー' +
      '<figure class="is-large">' +
      '  <img src="/assets/images/special-fake02.jpg">' +
      '</figure>' +
      '灼熱の要塞</h1>' +
      '<time>2019年製作<br>' +
      '原題：Razzie Rizing<br>' +
      '制作：エディ・カッサーノ</time>' +
      '<div class="star is-large">' +
      '  <span class="white">★</span><span class="black">☆☆☆☆</span>　<span>1.02点</span>' +
      '</div>' +
      '<section class="comments">' +
      '  <article>' +
      '    <header>' +
      '      <h1>無題</h1>' +
      '      <div class="star">' +
      '        採点なし' +
      '      </div>' +
      '    </header>' +
      '    <p>Makoto_Eが盛り上がっているが、コイツは映画秘宝の愛読者だろうな。</p>' +
      '    <div>' +
      '      <span>前川前蔵 さん</span>' +
      '      <time>2020年8月3日 22時17分</time>' +
      '    </div>' +
      '  </article>' +
      '  <article>' +
      '    <header>' +
      '      <h1>シリーズ最低</h1>' +
      '      <div class="star">' +
      '        <span class="white">★</span><span class="black">☆☆☆☆</span>' +
      '      </div>' +
      '    </header>' +
      '    <p>歴代シリーズでも最低な出来だ。ラジー賞連覇おめでとう。</p>' +
      '    <div>' +
      '      <span>パシリム35点 さん</span>' +
      '      <time>2020年6月6日 19時32分</time>' +
      '    </div>' +
      '  </article>' +
      '  <article>' +
      '    <header>' +
      '      <h1>ぜひともオススメ！！</h1>' +
      '      <div class="star">' +
      '        <span class="white">★★★★★</span><span class="black"></span>' +
      '      </div>' +
      '    </header>' +
      '    <p>『灼熱の要塞』は世紀の傑作と断言する！星5つじゃ足りない、いや、五億くらいだ！<br>' +
      'まずおすすめのアクションシーンは、大勢の敵を割り箸だけでやっつける割り箸アクション。日本の殺陣以上の迫力で、傑作『カブキマン』へのリスペクトを感じた。劇中の「お前らはもっとライスを食べたほうがいい…もちろん箸でな！」は多様な食文化へのメッセージを含んでてグッと来た。<br>' +
      'それだけじゃなく、背景演出にも凝っていて要塞が夕焼けの海に沈んでイルカが跳ね回るラストの美しさはジャッキーの『ゴージャス』を思い出して、心がホッコリする。<br>' +
      'そして、なんといってもクライマックスで主人公ラジーが恋人のために一人で要塞に乗り込んでいくシーンは何回見ても涙が止まらないくらい…「パイオツには気をつけろよ…」と言い残し敵もろとも散るところなんて…もう…。<br>' +
      '他にもエディ・カッサーノが手掛けた灼熱シリーズは多くあり、中でも『暴走列車』『沈没船』は俺にとってはバイブルと断言してもいい！<br>' +
      'シリーズ共通の主人公ラジーは<br>' +
      '『どんな苦境にあっても諦めず戦い、勝ち目が無くても大切な人を守るために全力を尽くす』<br>' +
      'という、男として…　いや、人として大切なものをテーマとして掲げてるので是非とも要チェックして欲しい！</p>' +
      '    <div>' +
      '      <span>Makoto_E さん</span>' +
      '      <time>2020年5月26日 01時28分</time>' +
      '    </div>' +
      '  </article>' +
      '  <article>' +
      '    <header>' +
      '      <h1>時間の価値</h1>' +
      '      <div class="star">' +
      '        <span class="white">★</span><span class="black">☆☆☆☆</span>' +
      '      </div>' +
      '    </header>' +
      '    <p>時間の無駄でした。どうやったらこんな映画を作れるのか…ハリウッドはまだ景気がいいんだね。</p>' +
      '    <div>' +
      '      <span>ジャンボリアン さん</span>' +
      '      <time>2019年11月5日 13時45分</time>' +
      '    </div>' +
      '  </article>' +
      '  <article>' +
      '    <header>' +
      '      <h1>う〜ん…</h1>' +
      '      <div class="star">' +
      '        <span class="white">★</span><span class="black">☆☆☆☆</span>' +
      '      </div>' +
      '    </header>' +
      '    <p>山無し谷無しな展開、ポップコーンの味しか感じられなかった。ラジーって名前で星一つあげる。</p>' +
      '    <div>' +
      '      <span>コレボンヌ さん</span>' +
      '      <time>2019年8月9日 21時50分</time>' +
      '    </div>' +
      '  </article>' +
      '</section>'
  },
  'thanks04': {
    title: 'THANKS!イラスト　第4話分',
    image: '/assets/images/special-banner-thanks04.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks04.jpg">' +
      '  <figcaption>作画監督・EDアニメーター：野崎あつこ</figcaption>' +
      '</figure>'
  },
  'fake01': {
    title: '特集記事「エディ・カッサーノ氏の光と影」',
    image: '/assets/images/special-banner-fake01.jpg',
    button: '情報提供はこちらから',
    twitter: '#今週もプリテンドされました #灼熱シリーズ #ラジー賞常連 #謎の新事業とは #長年追うが捕まえられない #誰がオタクだべ #グレプリ',
    text:
      '<h1 class="title">特集記事<br>「エディ・カッサーノ氏の光と影」</h1>' +
      '<time>2020.07.29</time>' +
      '<figure class="is-large">' +
      '  <img src="/assets/images/special-fake01.jpg">' +
      '</figure>' +
      '<h2>ー大物映画プロデューサー、その裏の顔とは</h2>' +
      '<p>先日、脱税で捕まるも瞬く間に保釈されたエディ・カッサーノ氏（以下カッサーノ氏と記載）。彼とマフィア組織の繋がりを弊誌に明かしたのは、元ギャングのジョンソン氏（仮名）だ。</p>' +
      '<p>カッサーノ氏といえばB級映画『灼熱』シリーズで有名なプロデューサー。彼の映画を観たことはない読者諸氏も、度々の脱税報道は耳にしたことがあるだろう。なにより驚くのが、何度脱税で捕まっても、即座に保釈金を用意する資金力である。</p>' +
      '<p>今回の保釈金もなんと１００万ドル。とても『灼熱』シリーズからの収入だけで払える金額とは思えない。</p>' +
      '<p>我々は独自調査すべく、ロサンゼルス・カッサーノ邸へ向かった。ビバリーヒルズにあるその豪邸は、２メートル超の壁に取り囲まれ、正面入口には、柄の悪い連中がたむろし、訪問者を寄せ付けない。記者はその中の一人「S」に、見覚えがあった。彼は元々ロス近郊のギャングのボスとして有名だったが、近年パタリと姿を消していた。こうして、カッサーノ氏のボディガードになっているようとは、裏社会の勢力争いはそれだけシビアということなのだろう。</p>' +
      '<p>カッサーノ氏の豪邸で連日連夜のように開催されるパーティーには、多数の著名人や美女が訪れている。R・〇リー、S・〇ブラヒム、J・エ〇スタイン、J・〇ールマン…交友関係も多彩だ。</p>' +
      '<p>先日ロスの外れにて急性麻薬中毒で死亡した某女優も、カッサーノ氏と会っていたという。</p>' +
      '<p>調査すること数日、記者はいかにもやり手なフランス人とオタク風の日本人の男性二人組が、カッサーノ氏の豪邸に入り浸っていることに気づいた。我々は外出するカッサーノ氏に突撃取材も敢行した。「新しい事業を進めることになった」らしく終始ご機嫌で、「事業が上手くいけば、州知事選にでも出てみるか」と冗談気味に言うほど…（ちなみに「灼熱」シリーズ新作の噂を尋ねたところ、機嫌が悪くなってしまった）</p>' +
      '<p>弊誌は取材の過程で、長年カッサーノ氏を追うロス市警のA警部とコンタクトを取ることに成功した。ハリウッドの闇は深いが、弊誌は今後もカッサーノ氏の徹底取材を続けていく。</p>'
  },
  'thanks03': {
    title: 'THANKS!イラスト　第3話分',
    image: '/assets/images/special-banner-thanks03.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks03.jpg">' +
      '  <figcaption>デザインワークス・作画監督：奥田明世</figcaption>' +
      '</figure>'
  },
  'thanks02': {
    title: 'THANKS!イラスト　第2話分',
    image: '/assets/images/special-banner-thanks02.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks02.jpg">' +
      '  <figcaption>デザインワークス・作画監督：石橋翔祐</figcaption>' +
      '</figure>'
  },
  'thanks01': {
    title: 'THANKS!イラスト　第1話分',
    image: '/assets/images/special-banner-thanks1.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-thanks1.jpg">' +
      '  <figcaption>デザインワークス・作画監督：清水 慶太</figcaption>' +
      '</figure>'
  },
  'countdown0': {
    title: 'COUNTDOWNイラスト　放送当日',
    image: '/assets/images/special-banner-cd0.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-cd0.jpg">' +
      '  <figcaption>サブキャラクターデザイン・総作画監督：加藤寛崇</figcaption>' +
      '</figure>'
  },
  'countdown1': {
    title: 'COUNTDOWNイラスト　あと1日',
    image: '/assets/images/special-banner-cd1.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-cd1.jpg">' +
      '  <figcaption>美術ボード：須藤 裕美子（Bamboo）</figcaption>' +
      '</figure>'
  },
  'countdown2': {
    title: 'COUNTDOWNイラスト　あと2日',
    image: '/assets/images/special-banner-cd2.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-cd2.jpg">' +
      '  <figcaption>背景：宗政 拓也（Bamboo）</figcaption>' +
      '</figure>`'
  },
  'countdown3': {
    title: 'COUNTDOWNイラスト　あと3日',
    image: '/assets/images/special-banner-cd3.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-cd3.jpg">' +
      '  <figcaption>背景：柳川 真梨（Bamboo）</figcaption>' +
      '</figure>`'
  },
  'countdown4': {
    title: 'COUNTDOWNイラスト　あと4日',
    image: '/assets/images/special-banner-cd4.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-cd4.jpg">' +
      '  <figcaption>美術ボード：岡本 春美（Bamboo）</figcaption>' +
      '</figure>`'
  },
  'countdown5': {
    title: 'COUNTDOWNイラスト　あと5日',
    image: '/assets/images/special-banner-cd5.jpg',
    text:
      '<figure>' +
      '  <img src="/assets/images/special-cd5.jpg">' +
      '  <figcaption>美術監督：竹田 悠介（Bamboo）</figcaption>' +
      '</figure>'
  }
}



// WEBPACK FOOTER //
// ./src/data/special.js